function* extractIntervals(intervals, duration, intervalBtwn) {
  if (intervals.length === 0)
    return [];
  const sorted = [...intervals].sort((a, b) => a.low - b.low);
  let nextStart = sorted[0].low;
  for (const { low, high } of sorted) {
    if (nextStart < low) {
      nextStart = low;
    }
    while (nextStart + duration <= high) {
      yield { low: nextStart, high: nextStart + duration };
      nextStart += duration + intervalBtwn;
    }
  }
}
export {
  extractIntervals
};
